import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import client from '../api/client';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

function AcceptInvite() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();

  const params = new URLSearchParams(location.search);
  const token = params.get('token') || '';

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!token) {
    return (
      <div className="login-shell">
        <div className="login-card">
          <div className="login-brand"><h1>Invite Missing</h1></div>
          <p>No invite token was provided. Ask your administrator for a new invite link.</p>
          <div className="login-links"><Link to="/login">Back to sign in</Link></div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await client.post('/api/auth/accept-invite', {
        token,
        firstName,
        lastName,
        password: password || undefined,
      });
      if (res.data?.authenticated) {
        await refresh();
        navigate('/', { replace: true });
      } else {
        setError('Could not accept invite.');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Could not accept invite.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">VD</div>
          <h1>Welcome to VitalData</h1>
          <p>Finish setting up your account</p>
        </div>
        {error && <div className="login-error">{error}</div>}
        <form className="login-form" onSubmit={handleSubmit}>
          <label>First name
            <input value={firstName} onChange={e => setFirstName(e.target.value)} />
          </label>
          <label>Last name
            <input value={lastName} onChange={e => setLastName(e.target.value)} />
          </label>
          <label>Password (optional, if you prefer password over Google)
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" />
          </label>
          <label>Confirm password
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" />
          </label>
          <button type="submit" disabled={submitting}>
            {submitting ? 'Setting up...' : 'Accept invite'}
          </button>
        </form>
        <div className="login-links"><Link to="/login">Back to sign in</Link></div>
      </div>
    </div>
  );
}

export default AcceptInvite;
